import { render, staticRenderFns } from "./InvestmentRecommend.vue?vue&type=template&id=add73376&scoped=true"
import script from "./InvestmentRecommend.vue?vue&type=script&lang=js"
export * from "./InvestmentRecommend.vue?vue&type=script&lang=js"
import style0 from "../fta.css?vue&type=style&index=0&id=add73376&prod&scoped=true&lang=css&external"
import style1 from "./InvestmentRecommend.less?vue&type=style&index=1&id=add73376&prod&lang=less&scoped=true&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "add73376",
  null
  
)

export default component.exports